import styled from "styled-components";
import { Col , Row } from "@vds/grids";
import { RadioBoxGroup } from "@vds/radio-boxes";

export const ColNoPad = styled(Col)`
  padding-right: 0;
  padding-left: 0;
`;

export const RowNoPad = styled(Row)`
  > div {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  position: absolute;
  right: ${({isMobile}) => (isMobile ? "16px" : "24px")};
  top: ${({isMobile}) => (isMobile ? "16px" : "24px")};
`;

export const ButtonContainerMonarch = styled.div`
  display: flex;
  gap: 16px;
`;

export const DeviceInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 280px;
  @media (max-width: 545px) {
    width: unset;
  }
`;
export const DeviceInfoContainerNew = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 500px;
  padding-left: 12px;
  @media (max-width: 545px) {
    width: unset;
  }
`;
export const LeftImageSection = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2rem;
  flex-grow: 1;
  width: 410px;
  padding-top:25px;
  @media (max-width: 545px) {
    flex-direction: row;
    gap: 1rem;
    width: auto;
    img {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;
export const LeftImageSectionNew = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex-grow: 1;
  width: 510px;
  @media (max-width: 545px) {
    flex-direction: column;
    gap: 1rem;
    width: auto;
    img {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

export const RightSectionNew = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledConatinerTop = styled.div`
  display: flex;
  justify-content: space-between;
`

export const AsyncWrapper = styled.div`
margin-right: 12px;
>div >div[class*="BkXqJ2iByEOs3g8kr7ku1A=="] >div[class*="Mo1tGOq6GgjqvcQcjvwLSw=="]{
  position: relative;
  pointer-events: auto;
}
`;

export const CustomRadioBoxGroup = styled(RadioBoxGroup)`
  @media (max-width: 767px) {
    [class^="SubLabel"] {
      padding-bottom: 1rem;
      width: 298px;
    }
  }
`;

export const SimRadioBoxGroup = styled(RadioBoxGroup)`
  .LabelContent {
    font-weight: 700;
  }
`;

export const TileGroup = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const OptionsTile = styled.div`
  border-radius: 12px;
  background: #FFFFFF;
  border: ${(props) => (props.selected ? '2px solid #000000' : 'none')};
`;

export const OptionsHeader = styled.div`
  min-height: 72px; 
  padding: 24px 24px 0px 24px;
  display: flex;
  justify-content: space-between;
`;

export const OptionsDesc = styled.div`
  min-height: 84px;
  padding: 24px 24px 0px 24px;
`;
export const OptionsDesc2 = styled.div`
  min-height: 104px;
  padding: 24px 24px 0px 24px;
`;

export const OptionsAction = styled.div`
  padding: 32px 24px;
`;

export const OptionsSelected = styled.div`
  padding: 32px 0px;
`;

export const SelectedCont = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  background: #F8F3E9;
`;

export const IconCont = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PromoBanner = styled.div`
  border-radius: 12px 12px 0px 0px;
  background: #E10014;
  padding: 12px 24px;
  display: flex;
  gap: 8px;
  align-items: center;
`;